import { dbHelpers } from "@/lib/db";
import { TrackAnalysis } from "./types";
export class TrackAnalysisService {
  public static async saveAnalysis(trackId: string, analysis: TrackAnalysis): Promise<void> {
    // Ensure analysis.trackId is correctly assigned before saving,
    // as it's used as the keyPath in IndexedDB.
    if (!analysis.trackId || analysis.trackId !== trackId) {
      console.warn("TrackAnalysisService: analysis.trackId is missing or does not match trackId. Assigning it now.");
      analysis.trackId = trackId;
    }
    await dbHelpers.saveHapticAnalysis(analysis);
  }

  public static async getAnalysis(trackId: string): Promise<TrackAnalysis | null> {
    const analysis = await dbHelpers.getHapticAnalysis(trackId);
    return analysis || null; // Return null if undefined
  }

  // getAllAnalyses() is removed as it's not directly replaced by a dbHelper
  // and its previous localStorage implementation is no longer relevant.
  // If needed, a getAllHapticAnalyses helper could be added to db.ts.
}
